import { useMemo } from 'react';

import InputTextField from '$app-web/components/input-text-field';
import { getIsACT } from '$app-web/utils';

const CustomInputTextField = (props) => {
    const isACT = useMemo(() => getIsACT(), []);

    return <InputTextField color={isACT ? 'actHealth' : 'default'} {...props} />;
};

export default CustomInputTextField;
